import { IProjectAttribute } from '../../interfaces/iproject-attribute';
import { ProjectType } from '../project-type';

export class ProjectAttributeBase {
  ProjectAttributeId: number;
  ProjectTypeId: number;
  AttributeName: string;
  AttributeValueSql: string;
  LastUpdatedDate: Date;
  LastUpdatedUser: string;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  ProjectType?: ProjectType;

  constructor(item?: IProjectAttribute) {
    if (item) {

      this.ProjectAttributeId = item.ProjectAttributeId;
      this.ProjectTypeId = item.ProjectTypeId;
      this.AttributeName = item.AttributeName;
      this.AttributeValueSql = item.AttributeValueSql;
      this.LastUpdatedDate = item.LastUpdatedDate ? new Date(item.LastUpdatedDate) : null;
      this.LastUpdatedUser = item.LastUpdatedUser;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.ProjectType = new ProjectType(item.ProjectType);
    }
  }
}